/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { request } from '@/fetch/core';
import { Method } from '@/fetch/core/util';
import { ProductKey } from '@inspector/utils/constant';
import { AlarmCode } from '@inspector/utils/constant';
export enum DeviceStatus {
  ABNORMAL = 'ABNORMAL',
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
  ALL = 'ALL',
}

export const DeviceStatusMap: any = {
  [DeviceStatus.ABNORMAL]: '异常',
  [DeviceStatus.ONLINE]: '在线',
  [DeviceStatus.OFFLINE]: '离线',
  [DeviceStatus.ALL]: '全部',
};
export interface AlarmEvent {
  alarmCode: AlarmCode;
  alarmLevelName: string;
  alarmCodeName: string;
  reportTime: string;
  alarmLevel: string;
}
export interface BoardInfo {
  deviceName: string;
  groupLevelName: string;
  remarkName: string;
  productModelName: string;
  realtimeStatus: DeviceStatus;
  chargingState: boolean;
  alarmEvent: AlarmEvent[];
  power: number;
  taskType: string | null;
  taskTypeName: string | null;
  taskEtcTime: number | null;
  remoteCall: boolean | null;
  followUser: string | null;
  workModeName: string | null;
}
class BoardApi {
  fetchDomain = `${location.protocol}//${process.env.JDX_APP_CLOUD_FETCH_DOMAIN}`;
  getGroupTree = (): Promise<any> => {
    const requestParams: RequestOptions = {
      method: Method.POST,
      absoluteURL: `${location.protocol}//${process.env.JDX_APP_CLOUD_FETCH_DOMAIN}/monitor/web/robot/groupTree`,
      headers: {
        'LOP-DN': process.env.JDX_APP_REQUEST_HEADER!,
      },
      body: {
        productKey: ProductKey,
      },
    };

    return request(requestParams);
  };
  pageSearch = (params: {
    productKey: string;
    groupNo: string;
    realtimeStatus: DeviceStatus;
    pageNum: number;
    pageSize: number;
  }): Promise<any> => {
    const requestParams: RequestOptions = {
      method: Method.POST,
      absoluteURL: `${location.protocol}//${process.env.JDX_APP_CLOUD_FETCH_DOMAIN}/monitor/web/robot/pageSearch`,
      headers: {
        'LOP-DN': process.env.JDX_APP_REQUEST_HEADER!,
      },
      body: {
        ...params,
        realtimeStatus:
          params.realtimeStatus === DeviceStatus.ALL
            ? ''
            : params.realtimeStatus,
      },
    };

    return request(requestParams);
  };

  getBasicInfo = (params: {
    productKey: string;
    deviceName: string;
  }): Promise<any> => {
    const requestParams: RequestOptions = {
      method: Method.POST,
      absoluteURL: `${location.protocol}//${process.env.JDX_APP_CLOUD_FETCH_DOMAIN}/monitor/web/robot/basic`,
      headers: {
        'LOP-DN': process.env.JDX_APP_REQUEST_HEADER!,
      },
      body: params,
    };

    return request(requestParams);
  };

  getRealtimeStatus = (params: { productKey: string; deviceName: string }) => {
    const requestParams: RequestOptions = {
      method: Method.POST,
      absoluteURL: `${location.protocol}//${process.env.JDX_APP_CLOUD_FETCH_DOMAIN}/monitor/web/robot/realtimeStatus`,
      headers: {
        'LOP-DN': process.env.JDX_APP_REQUEST_HEADER!,
      },
      body: params,
    };

    return request(requestParams);
  };

  getAbnormal = (params: { productKey: string; deviceName: string }) => {
    const requestParams: RequestOptions = {
      method: Method.POST,
      absoluteURL: `${location.protocol}//${process.env.JDX_APP_CLOUD_FETCH_DOMAIN}/monitor/web/robot/abnormal`,
      headers: {
        'LOP-DN': process.env.JDX_APP_REQUEST_HEADER!,
      },
      body: params,
    };

    return request(requestParams);
  };

  getShadowEventLog = (params: {
    productKey: string;
    deviceName: string;
    startTime: string;
    endTIme: string;
  }) => {
    const requestParams: RequestOptions = {
      method: Method.POST,
      absoluteURL: `${location.protocol}//${process.env.JDX_APP_CLOUD_FETCH_DOMAIN}/shadow/web/robot/event/list`,
      headers: {
        'LOP-DN': process.env.JDX_APP_REQUEST_HEADER!,
      },
      body: params,
    };
    return request(requestParams);
  };

  getMapInfo = (params: { number: string; version: string }) => {
    const requestParams: RequestOptions = {
      method: Method.POST,
      absoluteURL: `${location.protocol}//${process.env.JDX_APP_CLOUD_FETCH_DOMAIN}/k2/indoorMap/web/mapInfo/get_map_element`,
      headers: {
        'LOP-DN': process.env.JDX_APP_REQUEST_HEADER!,
      },
      body: params,
    };
    return request(requestParams);
  };
  solveAlarm = (params: {
    productKey: string;
    deviceName: string;
    alarmCode: string;
  }) => {
    const requestParams: RequestOptions = {
      method: Method.POST,
      absoluteURL: `${location.protocol}//${process.env.JDX_APP_CLOUD_FETCH_DOMAIN}/monitor/web/robot/issue/adopt`,
      headers: {
        'LOP-DN': process.env.JDX_APP_REQUEST_HEADER!,
      },
      body: params,
    };
    return request(requestParams);
  };

  asArrived = (params: { productKey: string; deviceName: string }) => {
    const requestParams: RequestOptions = {
      method: Method.POST,
      absoluteURL: `${location.protocol}//${process.env.JDX_APP_CLOUD_FETCH_DOMAIN}/monitor/web/robot/command/asArrived`,
      headers: {
        'LOP-DN': process.env.JDX_APP_REQUEST_HEADER!,
      },
      body: params,
    };
    return request(requestParams);
  };

  getAbnormalList = (params: {
    pageNum: number;
    pageSize: number;
    remarkName?: string;
    productKey?: string;
    stationName?: string;
    workMode?: string;
    groupNo?: string;
    startTime?: string;
    endTime?: string;
    processMode?: string;
    followUser?: string;
  }) => {
    const requestParams: RequestOptions = {
      method: Method.POST,
      absoluteURL: `${location.protocol}//${process.env.JDX_APP_CLOUD_FETCH_DOMAIN}/monitor/web/robot/abnormal/page`,
      headers: {
        'LOP-DN': process.env.JDX_APP_REQUEST_HEADER!,
      },
      body: params,
    };
    return request(requestParams);
  };
  getMapByGroup = (params: { productKey: string; groupOne: string }) => {
    const requestParams: RequestOptions = {
      method: Method.POST,
      absoluteURL: `${location.protocol}//${process.env.JDX_APP_CLOUD_FETCH_DOMAIN}/monitor/web/robot/map/getMapByGroup`,
      headers: {
        'LOP-DN': process.env.JDX_APP_REQUEST_HEADER!,
      },
      body: params,
    };
    return request(requestParams);
  };
  getVideoUrl = (vehicleName: string) => {
    const requestParams: RequestOptions = {
      method: Method.POST,
      path: '/monitor/web/video/url',
      body: {
        vehicleName,
      },
    };
    return request(requestParams);
  };
  emergencyStop = (params: { productKey: string; deviceName: string }) => {
    const requestParams: RequestOptions = {
      method: Method.POST,
      absoluteURL: `${location.protocol}//${process.env.JDX_APP_CLOUD_FETCH_DOMAIN}/monitor/web/robot/command/emergency_stop`,
      headers: {
        'LOP-DN': process.env.JDX_APP_REQUEST_HEADER!,
      },
      body: params,
    };
    return request(requestParams);
  };
  recovery = (params: { productKey: string; deviceName: string }) => {
    const requestParams: RequestOptions = {
      method: Method.POST,
      absoluteURL: `${location.protocol}//${process.env.JDX_APP_CLOUD_FETCH_DOMAIN}/monitor/web/robot/command/recovery`,
      headers: {
        'LOP-DN': process.env.JDX_APP_REQUEST_HEADER!,
      },
      body: params,
    };
    return request(requestParams);
  };
  reboot = (params: { productKey: string; deviceName: string }) => {
    const requestParams: RequestOptions = {
      method: Method.POST,
      absoluteURL: `${location.protocol}//${process.env.JDX_APP_CLOUD_FETCH_DOMAIN}/monitor/web/robot/command/reboot`,
      headers: {
        'LOP-DN': process.env.JDX_APP_REQUEST_HEADER!,
      },
      body: params,
    };
    return request(requestParams);
  };

  restart = (params: { productKey: string; deviceName: string }) => {
    const requestParams: RequestOptions = {
      method: Method.POST,
      absoluteURL: `${location.protocol}//${process.env.JDX_APP_CLOUD_FETCH_DOMAIN}/monitor/web/robot/command/restart`,
      headers: {
        'LOP-DN': process.env.JDX_APP_REQUEST_HEADER!,
      },
      body: params,
    };
    return request(requestParams);
  };

  getDeviceRoute = (params: { productKey: string; deviceName: string }) => {
    const requestParams: RequestOptions = {
      method: Method.POST,
      absoluteURL: `${location.protocol}//${process.env.JDX_APP_CLOUD_FETCH_DOMAIN}/monitor/web/robot/map/getDeviceRoute`,
      headers: {
        'LOP-DN': process.env.JDX_APP_REQUEST_HEADER!,
      },
      body: params,
    };
    return request(requestParams);
  };
}

export default BoardApi;
